import { render, staticRenderFns } from "./FieldNumber.vue?vue&type=template&id=6d36bbf2"
import script from "./FieldNumber.vue?vue&type=script&lang=js"
export * from "./FieldNumber.vue?vue&type=script&lang=js"
import style0 from "./FieldNumber.vue?vue&type=style&index=0&id=6d36bbf2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports